import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { HttpClient, HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { filter } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { EnvironmentconfigService } from 'src/app/shared/service/environmentconfig.service';
import { WebApiService } from 'src/app/shared/service/webapi.service';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { URLConst } from 'src/app/shared/const/url.const';

@Component({
  selector: 'app-edit-wmsm-StatementMaintain-fx',
  templateUrl: './edit-wmsm-StatementMaintain-fx.component.html',
  styleUrls: ['./edit-wmsm-StatementMaintain-fx.component.scss']
})
export class EditWmsmStatementMaintainFxComponent implements OnInit {
  @Input() RNO: string = '';
  @Input() vendorCode: string = '';
  @Input() companyERP: string = '';
  @Input() currency: string = 'USD';
  // 父組件傳入的收貨明細（與 RMB 一致的結構）
  @Input() receiptDetails: any[] = [];
  @Output() serialNumbersChange = new EventEmitter<string[]>();
  @Output() checkInvoiceItemRequest = new EventEmitter<void>();
  @Output() returnRequest = new EventEmitter<void>();

  loading = false;
  pageSize = 20;
  pageIndex = 1;

  validateForm: FormGroup;
  get aliases(): FormArray { return this.validateForm.get('aliases') as FormArray; }

  InvoiceInfoSerialNumberList: any[] = [];
  SerialNumberInInvoice = true;
  InvoiceSerialNumberIsNull = true;
  foreignAmountsIncomplete = false;
  dateFormat = 'yyyy/MM/dd';

  constructor(
    private fb: FormBuilder,
    private message: NzMessageService,
    private modal: NzModalService,
    private translate: TranslateService,
    private Environment: EnvironmentconfigService,
    private WebApiService: WebApiService,
  ) { }

  ngOnInit(): void {
    // 初始化非RMB的表單結構
    this.validateForm = this.fb.group({
      aliases: this.fb.array([])
    });
    // 進入頁面即拉取外幣發票信息並預填
    this.loadForeignInvoices();
  }

  private loadForeignInvoices(): void {
    this.loading = true;
    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.GettForeignInvoiceInfoListDto.url}`;
    const params = {
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      data: {
        Rno: this.RNO
      },
    };

    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        this.loading = false;
        // 清空現有行
        while (this.aliases.length > 0) {
          this.aliases.removeAt(0);
        }
        if (res && res.status == this.Environment.authConfig.wmsmStatus && Array.isArray(res.data)) {
          const invoices = res.data;
          for (const invoice of invoices) {
            const recognizedInvoiceNo = invoice.invoice || null;
            const recognizedInvoiceDateObj = invoice.invoiceDate ? new Date(invoice.invoiceDate) : null;
            const recognizedTotal = invoice.invoiceTotal !== undefined && invoice.invoiceTotal !== null
              ? parseFloat(invoice.invoiceTotal)
              : null;

            const manualInvoiceNo = invoice.manualInvoiceNumber || recognizedInvoiceNo;
            const manualInvoiceDateObj = invoice.manualInvoiceDate ? new Date(invoice.manualInvoiceDate) : recognizedInvoiceDateObj;
            const manualInvoiceAmountRaw = invoice.manualInvoiceAmount ?? null;
            const manualTaxAmountRaw = invoice.manualTaxAmount ?? null;
            const manualInvoiceAmount = manualInvoiceAmountRaw ?? invoice.invoiceAmount ?? null;
            const manualTaxAmount = manualTaxAmountRaw ?? invoice.taxAmount ?? null;
            const manualTotalSource = invoice.manualInvoiceTotal ?? null;
            const manualTotal = manualTotalSource ?? (recognizedTotal !== null ? recognizedTotal : null);

            const recognizedPresent = (recognizedInvoiceNo || recognizedInvoiceDateObj || recognizedTotal !== null);
            const userDecision = (
              (manualInvoiceNo && manualInvoiceNo !== recognizedInvoiceNo) ||
              (manualInvoiceDateObj && recognizedInvoiceDateObj && manualInvoiceDateObj.getTime() !== recognizedInvoiceDateObj.getTime()) ||
              (manualTotal !== null && recognizedTotal !== null && Math.abs(manualTotal - recognizedTotal) > 0.000001)
            ) ? 'user' : 'pending';

            // 初始鎖定策略：
            // 1. 有識別結果且未被用戶改動(userDecision != 'user') -> 鎖定全部可編輯欄位
            // 2. 用戶已改動過的行(userDecision == 'user') -> 保持可編輯
            // 3. 沒有識別結果的初始行 -> 可編輯（日期/號碼），金額欄位按現有規則
            const shouldLock = recognizedPresent && userDecision !== 'user';

            const newRow = this.fb.group({
              InvoiceSerialNumber: [{ value: invoice.invoiceItem, disabled: true }, [Validators.required]],
              InvoiceDate: [{ value: manualInvoiceDateObj, disabled: shouldLock }, [Validators.required]],
              InvoiceNo: [{ value: manualInvoiceNo, disabled: shouldLock }, [Validators.required]],
              InvoiceAmountBeforeTax: [{ value: manualInvoiceAmount, disabled: shouldLock }],
              Taxes: [{ value: manualTaxAmount, disabled: shouldLock }],
              TotalAmount: [{ value: manualTotal != null ? manualTotal.toString() : null, disabled: shouldLock }],
              parsedTotalAmount: [recognizedTotal],
              userDecision: [userDecision],
              editMode: [recognizedPresent ? 'recognized' : 'initial'],
              recognizedData: [recognizedPresent ? { invoiceNo: recognizedInvoiceNo, invoiceDate: recognizedInvoiceDateObj, totalAmount: recognizedTotal } : null],
              isLocked: [shouldLock],
            });

            // 外幣：允許手動覆寫金額，預設不禁用
            this.aliases.push(newRow);
          }

          // 若接口無數據，至少增加一行
          if (this.aliases.length === 0) {
            this.addRow();
          }

          this.updateSerialNumberList();
          this.updateForeignAmountCompleteness();
          this.emitSerialsAndCheck();
          this.message.success(res.msg);
        } else {
          // 接口返回異常時，提供一行空白供手動輸入
          this.addRow();
          this.message.warning(res?.msg || this.translate.instant('MsgLoadFailed'));
        }
      },
      (error) => {
        this.loading = false;
        // 出錯也保證至少一行
        if (this.aliases.length === 0) {
          this.addRow();
        }
        this.updateSerialNumberList();
        this.updateForeignAmountCompleteness();
        this.message.error(error?.msg || this.translate.instant('MsgLoadFailed'));
      }
    );
  }

  addRow(): void {
    const newSerialNumber = this.aliases.length + 1;
    const newRow = this.fb.group({
      InvoiceSerialNumber: [{ value: newSerialNumber, disabled: true }, [Validators.required]],
      InvoiceDate: [null, [Validators.required]],
      InvoiceNo: [null, [Validators.required]],
      InvoiceAmountBeforeTax: [{ value: null, disabled: true }],
      Taxes: [{ value: null, disabled: true }],
      TotalAmount: [{ value: null, disabled: true }],
      parsedTotalAmount: [null],
      userDecision: ['pending'],
      editMode: ['initial'],
      recognizedData: [null],
      isLocked: [false],
    });
    this.aliases.push(newRow);
    this.updateSerialNumberList();
    this.updateForeignAmountCompleteness();
    this.emitSerialsAndCheck();
  }

  deleteRow(index: number): void {
    this.aliases.removeAt(index);
    this.updateSerialNumberList();
    this.CheckInvoiceItem();
    this.updateForeignAmountCompleteness();
    this.emitSerialsAndCheck();
  }


  // 切換手動編輯模式
  enableManualEdit(index: number): void {
    const control = this.aliases.at(index) as FormGroup;
    if (!control) return;
    control.get('editMode')?.setValue('editing');
    control.get('isLocked')?.setValue(false);
    this.setManualFieldState(control, false);
    this.message.info(`第 ${index + 1} 行可手動編輯`);
    this.updateForeignAmountCompleteness();
  }

  updateSerialNumberList(): void {
    const serialNumbers = this.aliases.getRawValue().map(row => row.InvoiceSerialNumber);
    this.InvoiceInfoSerialNumberList = [...new Set(serialNumbers.filter(sn => sn != null))];
    this.checkInvoiceInfo();
    this.updateForeignAmountCompleteness();
    this.serialNumbersChange.emit(this.InvoiceInfoSerialNumberList.map(sn => sn?.toString()));
  }

  private emitSerialsAndCheck(): void {
    this.serialNumbersChange.emit(this.InvoiceInfoSerialNumberList.map(sn => sn?.toString()));
    this.checkInvoiceItemRequest.emit();
  }

  CheckInvoiceItem(): void {
    if (!this.receiptDetails || this.receiptDetails.length === 0) {
      this.SerialNumberInInvoice = false;
      return;
    }
    this.SerialNumberInInvoice = this.receiptDetails.some(item =>
      item.invoiceItem === '' || item.invoiceItem === null
    );
  }

  checkInvoiceInfo(): void {
    if (this.aliases.controls.length === 0) {
      this.InvoiceSerialNumberIsNull = true;
      return;
    }
    const invoiceValues = this.aliases.getRawValue();
    this.InvoiceSerialNumberIsNull = invoiceValues.some(invoice =>
      invoice.InvoiceSerialNumber === '' || invoice.InvoiceSerialNumber === null
    );
  }

  shouldShowComparison(control: FormGroup, field: 'InvoiceNo' | 'InvoiceDate' | 'TotalAmount'): boolean {
    const recognized = this.getRecognizedPrimitive(control, field);
    const manual = this.getManualPrimitive(control, field);
    if (recognized === null || manual === null) return false;
    if (typeof recognized === 'number' && typeof manual === 'number') {
      return Math.abs(manual - recognized) > 0.000001;
    }
    return recognized !== manual;
  }

  getComparisonDisplay(control: FormGroup, field: 'InvoiceNo' | 'InvoiceDate' | 'TotalAmount'): string {
    const recognized = this.getRecognizedPrimitive(control, field);
    if (recognized === null) return '';
    if (typeof recognized === 'number') return this.formatNumberForDisplay(recognized);
    return recognized as string;
  }

  private getManualPrimitive(control: FormGroup, field: 'InvoiceNo' | 'InvoiceDate' | 'TotalAmount'): string | number | null {
    switch (field) {
      case 'InvoiceNo':
        return this.normalizeStringValue(control.get('InvoiceNo')?.value);
      case 'InvoiceDate':
        return control.get('InvoiceDate')?.value ? control.get('InvoiceDate')?.value : null;
      case 'TotalAmount':
        const v = control.get('TotalAmount')?.value;
        return v === null || v === '' ? null : Number(v);
      default:
        return null;
    }
  }

  private getRecognizedPrimitive(control: FormGroup, field: 'InvoiceNo' | 'InvoiceDate' | 'TotalAmount'): string | number | null {
    const recognizedData = control.get('recognizedData')?.value;
    if (!recognizedData) return null;
    switch (field) {
      case 'InvoiceNo':
        return this.normalizeStringValue(recognizedData.invoiceNo);
      case 'InvoiceDate':
        return recognizedData.invoiceDate || null;
      case 'TotalAmount':
        return typeof recognizedData.totalAmount === 'number' ? recognizedData.totalAmount : null;
      default:
        return null;
    }
  }

  private normalizeStringValue(value: any): string | null {
    if (value === null || value === undefined) return null;
    const normalized = value.toString().trim();
    return normalized === '' ? null : normalized;
  }

  private formatNumberForDisplay(value: number): string {
    if (value === null || value === undefined || isNaN(value)) return '';
    return value.toFixed(2);
  }

  // 計算總額（非RMB）
  calculateSum(i: number): void {
    const control = this.aliases.at(i) as FormGroup;
    if (!control) return;
    const beforeTax = parseFloat(control.get('InvoiceAmountBeforeTax')?.value) || 0;
    const taxes = parseFloat(control.get('Taxes')?.value) || 0;
    control.get('TotalAmount')?.setValue((beforeTax + taxes).toFixed(2));
    this.updateForeignAmountCompleteness();
  }

  // 失焦時校驗並可能彈窗確認
  validateAndConfirm(i: number): void {
    const control = this.aliases.at(i) as FormGroup;
    if (!control) return;
    const userDecision = control.get('userDecision')?.value;
    // 若已標記為用戶決定，則不再自動覆寫
    if (userDecision === 'user') return;

    const beforeTaxControl = control.get('InvoiceAmountBeforeTax');
    const taxesControl = control.get('Taxes');
    const recognizedTotal = parseFloat(control.get('parsedTotalAmount')?.value);
    if (isNaN(recognizedTotal)) return;

    const calculatedTotal = parseFloat(control.get('TotalAmount')?.value) || 0;
    const isBothFilled = (beforeTaxControl?.value !== null && beforeTaxControl?.value !== '') &&
      (taxesControl?.value !== null && taxesControl?.value !== '');

    // 僅當處於待決定且兩欄皆有值且與識別總額不一致時彈窗
    if (userDecision === 'pending' && isBothFilled && calculatedTotal.toFixed(2) !== recognizedTotal.toFixed(2)) {
      this.showConfirmationModal(i, calculatedTotal, recognizedTotal);
    } else {
      // 不彈窗且非用戶決定時，不主動清空手動輸入；僅更新完整性狀態
      // 如果用戶有輸入（任一金額欄有值），則標記為用戶決定，避免後續被系統清空
      const hasAnyManual = (beforeTaxControl?.value !== null && beforeTaxControl?.value !== '') ||
        (taxesControl?.value !== null && taxesControl?.value !== '');
      if (userDecision === 'pending' && hasAnyManual) {
        control.get('userDecision')?.setValue('user');
      }
    }
    this.updateForeignAmountCompleteness();
  }

  // 顯示金額衝突確認
  private showConfirmationModal(index: number, userTotal: number, recognizedTotal: number): void {
    const control = this.aliases.at(index) as FormGroup;
    this.modal.confirm({
      nzTitle: '金額不一致確認',
      nzContent: `手動金額：${userTotal.toFixed(2)}，識別金額：${recognizedTotal.toFixed(2)}。是否採用手動數值？`,
      nzOkText: '採用手動',
      nzCancelText: '採用識別',
      nzOnOk: () => {
        control.get('userDecision')?.setValue('user');
        this.message.success('已採用手動金額');
      },
      nzOnCancel: () => {
        control.get('userDecision')?.setValue('system');
        // 僅在用戶明確選擇採用識別時，才還原總額並清空明細兩欄
        control.get('InvoiceAmountBeforeTax')?.setValue(null);
        control.get('Taxes')?.setValue(null);
        control.get('TotalAmount')?.setValue(recognizedTotal.toFixed(2));
        this.message.info('已採用識別金額');
      }
    });
  }

  // 還原識別結果
  restoreRecognizedData(index: number): void {
    const control = this.aliases.at(index) as FormGroup;
    const recognized: any = control.get('recognizedData')?.value;
    if (!recognized) return;
    const totalStr = (typeof recognized.totalAmount === 'number') ? recognized.totalAmount.toFixed(2) : null;
    control.patchValue({
      InvoiceNo: recognized.invoiceNo,
      InvoiceDate: recognized.invoiceDate,
      TotalAmount: totalStr,
      parsedTotalAmount: recognized.totalAmount,
      InvoiceAmountBeforeTax: totalStr, // 還原時外幣未稅 = 含稅總價
      Taxes: '0.00', // 還原時稅金默認為 0
      editMode: 'recognized'
    });
    // 還原後重新鎖定所有欄位（等待用戶主動點“編輯”）
    ['InvoiceDate', 'InvoiceNo', 'InvoiceAmountBeforeTax', 'Taxes', 'TotalAmount'].forEach(f => control.get(f)?.disable());
    control.get('isLocked')?.setValue(true);
    this.message.success('已還原識別結果');
    this.updateForeignAmountCompleteness();
  }

  // 切換鎖定
  toggleLock(index: number): void {
    const control = this.aliases.at(index) as FormGroup;
    if (!control) return;
    const lockControl = control.get('isLocked');
    const nextState = !lockControl?.value;
    lockControl?.setValue(nextState);
    this.setManualFieldState(control, nextState);
    this.updateForeignAmountCompleteness();
  }

  // 控制欄位啟用/停用
  private setManualFieldState(control: FormGroup, disable: boolean): void {
    const targetFields = ['InvoiceDate', 'InvoiceNo', 'InvoiceAmountBeforeTax', 'Taxes', 'TotalAmount'];
    targetFields.forEach(field => {
      const c = control.get(field);
      if (!c) return;
      if (disable) c.disable(); else c.enable();
    });
  }

  // 完整性校驗：非RMB需至少有 TotalAmount 或 明細兩欄
  updateForeignAmountCompleteness = (): void => {
    const invoiceRows = this.aliases.getRawValue();
    this.foreignAmountsIncomplete = invoiceRows.some(row => {
      const hasTotal = row.TotalAmount !== null && row.TotalAmount !== '';
      const hasDetails = (row.InvoiceAmountBeforeTax !== null && row.InvoiceAmountBeforeTax !== '') &&
        (row.Taxes !== null && row.Taxes !== '');
      return !hasTotal && !hasDetails;
    });
  }

  // 上傳外幣發票檔，模擬識別結果（可逐步替換為真實API）
  async beforeUploadAttachment(index: number, file: any): Promise<boolean> {
    const control = this.aliases.at(index) as FormGroup;
    this.loading = true; // 立刻啟用 loading，接著讓 UI 先刷新
    // 釋放執行緒給變更檢測，避免大型文件 FormData 構建時造成短暫卡頓
    await Promise.resolve();
    // 準備表單資料，與父組件保持一致
    const formData = new FormData();
    formData.append('CompanyERP', this.companyERP || '');
    formData.append('VendorCode', this.vendorCode || '');
    formData.append('InvoiceNo', control.get('InvoiceNo')?.value || '');
    const invoiceDate = control.get('InvoiceDate')?.value;
    formData.append('InvoiceDate', invoiceDate ? this.formatDateToYYYYMMDD(invoiceDate) : '');
    formData.append('NetAmount', control.get('InvoiceAmountBeforeTax')?.value || '');
    formData.append('TaxAmount', control.get('Taxes')?.value || '');
    formData.append('TotalAmount', control.get('TotalAmount')?.value || '');
    formData.append('ItemNo', `${index}`);
    formData.append('InvoiceFile', file as any);
    const url = `${this.Environment.authConfig.wmsmUrl}/api/RtStatement/ValidateAndExtractForeignInvoiceInfo`;

    try {
      // 使用 Observable + firstValueFrom 替代 deprecated toPromise，提升可維護性
      const res: any = await this.WebApiService.doPost(url, formData).toPromise();
      if (res && res.status == this.Environment.authConfig.wmsmStatus && res.data && !res.data.extractMessage) {
        const data = res.data;
        const recognizedDate = data.invoiceDate ? new Date(data.invoiceDate) : null;
        // 回填識別結果到比較用的 recognizedData
        control.patchValue({
          recognizedData: {
            invoiceNo: data.invoiceNo,
            invoiceDate: recognizedDate,
            totalAmount: data.totalAmount
          },
          parsedTotalAmount: data.totalAmount,
          TotalAmount: data.totalAmount != null ? Number(data.totalAmount).toFixed(2) : null,
          editMode: 'recognized',
          userDecision: 'system'
        });
        // 直接將識別到的發票號與日期寫入控件，避免界面不顯示
        const currentInvNo = control.get('InvoiceNo')?.value;
        const currentInvDate = control.get('InvoiceDate')?.value;
        control.get('InvoiceNo')?.setValue(data.invoiceNo ?? currentInvNo ?? null);
        control.get('InvoiceDate')?.setValue(recognizedDate ?? currentInvDate ?? null);
        // 外幣識別成功後：未稅金額默認 = 總價；稅金默認 = 0
        if (data.totalAmount != null) {
          const totalStr = Number(data.totalAmount).toFixed(2);
          control.get('InvoiceAmountBeforeTax')?.setValue(totalStr);
          control.get('Taxes')?.setValue('0.00');
          control.get('TotalAmount')?.setValue(totalStr);
        } else {
          control.get('InvoiceAmountBeforeTax')?.setValue(null);
          control.get('Taxes')?.setValue('0.00');
        }
        // 成功識別後全部鎖定，等待用戶主動點“編輯”再開啟
        ['InvoiceDate', 'InvoiceNo', 'InvoiceAmountBeforeTax', 'Taxes', 'TotalAmount'].forEach(f => control.get(f)?.disable());
        control.get('isLocked')?.setValue(true);
        this.message.success(this.translate.instant('MsgRecognizedSuccess'));
      } else {
        const msg = res?.data?.extractMessage || this.translate.instant('MsgUploadFailed');
        this.message.error(msg);
        control.patchValue({ editMode: 'editing', recognizedData: null });
        this.enableManualEdit(index);
      }
    } catch (error) {
      this.message.error(this.translate.instant('MsgUploadFailed'));
      control.patchValue({ editMode: 'editing', recognizedData: null });
      this.enableManualEdit(index);
    } finally {
      this.loading = false;
      this.updateForeignAmountCompleteness();
    }
    return false; // 阻止上傳列表顯示附件
  }

  // 暫存保存（非RMB）
  saveData(): void {
    this.loading = true;
    const InvoiceInfo = this.aliases.controls
      .map((ctrl) => this.buildInvoiceInfoDtoFromControl(ctrl as FormGroup))
      .filter((dto) => dto.Invoice || dto.ManualInvoiceNumber);

    const ReceiptInfo = (this.receiptDetails || []).map(item => ({
      RNo: this.RNO,
      InvoiceItem: item.invoiceItem || null,
      Company: item.companyCode,
      PoNo: item.pono,
      PoLn: item.poln,
      RtNo: item.rtno,
      RtLn: item.rtln
    }));

    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.MaintainInvoiceInfo.url}`;
    const params = {
      data: {
        InvoiceInfoList: InvoiceInfo,
        ReceiptInfoList: ReceiptInfo,
        RNo: this.RNO,
        Currency: this.currency
      }
    };
    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (res && res.status == this.Environment.authConfig.wmsmStatus) {
          this.message.success(this.translate.instant('MsgSaveSuccess'));
        } else {
          this.message.error(res?.msg || this.translate.instant('MsgSaveFailed'));
        }
        this.loading = false;
      },
      (error) => {
        this.message.error(error?.msg || this.translate.instant('MsgSaveFailed'));
        this.loading = false;
      }
    );
  }

  // 最終提交（非RMB）
  Submit(): void {
    this.loading = true;
    // 構造後端需要的簡化發票結構
    const SubmitInvoiceInfo = this.aliases.controls
      .map((c) => c as FormGroup)
      .map((ctrl) => {
        const userDec = ctrl.get('userDecision')?.value;
        const isManual = userDec === 'user';
        const rec = ctrl.get('recognizedData')?.value || {};
        const recTotal = typeof rec.totalAmount === 'number' ? rec.totalAmount : null;
        const recInvNo = this.normalizeStringValue(rec.invoiceNo);
        const recInvDate = rec.invoiceDate || null;

        const manualInvNo = this.normalizeStringValue(ctrl.get('InvoiceNo')?.value);
        const manualInvDate = ctrl.get('InvoiceDate')?.value || null;
        const manualBeforeTax = this.toDecimalOrNull(ctrl.get('InvoiceAmountBeforeTax')?.value);
        const manualTaxes = this.toDecimalOrNull(ctrl.get('Taxes')?.value);

        // 取值策略：手動優先，否則用識別（外幣規則：Amount=Total, Taxamount=0）
        const invno = isManual ? manualInvNo : recInvNo;
        const invdate = isManual ? manualInvDate : recInvDate;
        const amount = isManual ? manualBeforeTax : (recTotal != null ? this.toDecimalOrNull(recTotal) : null);
        const taxamount = isManual ? manualTaxes : (recTotal != null ? 0 : null);

        return {
          InvoiceItem: (ctrl.get('InvoiceSerialNumber')?.value ?? '')?.toString(),
          Invdate: invdate ? this.formatDateToYYYYMMDD(invdate) : null,
          Invcode: ctrl.get('InvoiceCode')?.value || null,
          Invno: invno || null,
          Amount: amount,
          Taxamount: taxamount,
          IsManualEdited: !!isManual,
        };
      })
      .filter((item) => item.Invno != null);

    const goods = this.receiptDetails || [];
    const SubmitReceiptInfo = goods.map(item => ({
      RNo: this.RNO,
      InvoiceItem: item.invoiceItem != null ? String(item.invoiceItem) : null,
      Company: item.companyCode || null,
      Pono: item.pono || null,
      Poitemno: item.poln || null,
      Price: item.finalPrice ?? null,
      Rtno: item.rtno || null,
      Rtitemno: item.rtln || null,
      Qty: item.rtQty ?? null,
      Curr: item.currency || this.currency,
      Oamount: item.rtAmount ?? null,
      Tax: item.taxRate ?? null,
      Plantcode: item.plantCode || null,
      Afamount: item.invoiceAmount ?? null,
      Invseq: item.remark || null,
      Spec: item.spec || null
    }));

    if (!SubmitReceiptInfo || SubmitReceiptInfo.length === 0) {
      this.message.warning(this.translate.instant('MsgNoReceiptDetails'));
    }

    const url = `${this.Environment.authConfig.wmsmUrl}${URLConst.SubmitRtStatement.url}`;
    const params = {
      data: {
        RtStatementDetail: SubmitReceiptInfo,
        InvoiceInfo: SubmitInvoiceInfo,
        Rno: this.RNO,
        Currency: this.currency,
        CompanyNo: this.companyERP,
        VendorCode: this.vendorCode
      }
    };

    this.WebApiService.doPost(url, params).subscribe(
      (res) => {
        if (res && res.status == this.Environment.authConfig.wmsmStatus) {
          this.message.success(res.msg);
        } else {
          this.message.error(res?.msg || this.translate.instant('MsgSubmitFailed'));
        }
        this.loading = false;
      },
      (error) => {
        const errorMsg = error?.error?.title || error?.msg || this.translate.instant('MsgSubmitFailed');
        this.message.error(errorMsg);
        this.loading = false;
      }
    );
  }

  private formatDateToYYYYMMDD(date: Date | string): string {
    if (!date) return null as any;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private toDecimalOrNull(v: any): number | null {
    if (v === null || v === undefined || v === '') return null;
    const n = typeof v === 'string' ? parseFloat(v) : Number(v);
    if (isNaN(n)) return null;
    return Number(n.toFixed(2));
  }

  private numbersEqual(a: any, b: any): boolean {
    const na = this.toDecimalOrNull(a);
    const nb = this.toDecimalOrNull(b);
    if (na === null && nb === null) return true;
    if (na === null || nb === null) return false;
    return Math.abs(na - nb) < 0.000001;
  }

  private datesEqual(a: any, b: any): boolean {
    if (!a && !b) return true;
    if (!a || !b) return false;
    try {
      const da = new Date(a).getTime();
      const db = new Date(b).getTime();
      return da === db;
    } catch {
      return false;
    }
  }

  private buildInvoiceInfoDtoFromControl(ctrl: FormGroup) {
    const rec = ctrl.get('recognizedData')?.value || {};
    const recInvNo = this.normalizeStringValue(rec.invoiceNo);
    const recInvDate = rec.invoiceDate || null;
    const recTotal = typeof rec.totalAmount === 'number' ? rec.totalAmount : null;

    const manualInvNo = this.normalizeStringValue(ctrl.get('InvoiceNo')?.value);
    const manualInvDate = ctrl.get('InvoiceDate')?.value || null;
    const manualBeforeTax = ctrl.get('InvoiceAmountBeforeTax')?.value;
    const manualTaxes = ctrl.get('Taxes')?.value;
    const manualTotal = ctrl.get('TotalAmount')?.value;

    // 比較識別 vs 手動，逐欄位判斷差異
    const invNoDiff = manualInvNo !== recInvNo;
    const invDateDiff = !this.datesEqual(manualInvDate, recInvDate);
    const totalDiff = !this.numbersEqual(manualTotal, recTotal);
    const recognizedBeforeTax = recTotal; // 外幣：識別未稅=總額
    const recognizedTaxes = recTotal != null ? 0 : null; // 外幣：識別稅金=0
    const beforeTaxDiff = !this.numbersEqual(manualBeforeTax, recognizedBeforeTax);
    const taxesDiff = !this.numbersEqual(manualTaxes, recognizedTaxes);
    const isManualEdited = invNoDiff || invDateDiff || totalDiff || beforeTaxDiff || taxesDiff;

    return {
      Rno: this.RNO,
      InvoiceItem: (ctrl.get('InvoiceSerialNumber')?.value ?? '')?.toString(),
      // 識別（不可改）
      InvoiceDate: recInvDate ? this.formatDateToYYYYMMDD(recInvDate) : null,
      InvoiceCode: ctrl.get('InvoiceCode')?.value || null,
      Invoice: recInvNo,
      InvoiceAmount: this.toDecimalOrNull(recTotal),
      TaxAmount: recTotal != null ? 0 : null,
      InvoiceTotal: this.toDecimalOrNull(recTotal),
      // 手動（僅在不同時傳）
      ManualInvoiceNumber: invNoDiff ? manualInvNo : null,
      ManualInvoiceAmount: beforeTaxDiff ? this.toDecimalOrNull(manualBeforeTax) : null,
      ManualTaxAmount: taxesDiff ? this.toDecimalOrNull(manualTaxes) : null,
      ManualInvoiceTotal: totalDiff ? this.toDecimalOrNull(manualTotal) : null,
      ManualInvoiceDate: invDateDiff && manualInvDate ? this.formatDateToYYYYMMDD(manualInvDate) : null,
      IsManualEdited: isManualEdited
    };
  }
}
